import { EditorState, ContentState, convertFromRaw } from "draft-js";
import { stateFromHTML } from "draft-js-import-html";

export const generateHTMLFromValue = (value = "") => {
    let blocksFromHTML = "";
    try {
        blocksFromHTML = convertFromRaw(JSON.parse(value));
    } catch (e) {
        blocksFromHTML = ContentState.createFromText(value);
    }
    return EditorState.createWithContent(blocksFromHTML);
};

function parseStyleString(styleString) {
    return styleString.split(";").reduce((styles, rule) => {
        if (!rule) return styles;

        const [key, value] = rule.split(":");
        if (key && value) {
            const trimmedKey = key.trim();
            if (trimmedKey === "font-family") return styles;

            const camelKey = trimmedKey.replace(/-([a-z])/g, (g) =>
                g[1].toUpperCase()
            );
            styles[camelKey] = value.trim();
        }
        return styles;
    }, {});
}

export const generateJsonFromHTML = (value = "", styleMapRef) => {
    if (!value) return EditorState.createEmpty();

    let blocksFromHTML = "";
    try {
        blocksFromHTML = convertFromRaw(JSON.parse(value));
    } catch (e) {
        if (value && !value.includes("<")) {
            value = value.replace(/\n/g, "<br>");
        }

        const customInlineFn = (element, { Style }) => {
            if (element.tagName === "SPAN" && element.hasAttribute("style")) {
                const style = element.getAttribute("style");
                if (styleMapRef && !styleMapRef.current[style]) {
                    styleMapRef.current[style] = parseStyleString(style);
                }
                return Style(style);
            }
        };

        blocksFromHTML = stateFromHTML(value, { customInlineFn });
    }
    return EditorState.createWithContent(blocksFromHTML);
};
